import React from 'react';

import './ExternalContent.css';

const ExternalContent = (props) => {
  const { title, ...rest } = props;
  return (
    <iframe 
      className="ds__ExternalContent"
      title={title}
      {...rest}
		/>
  );
};

export default ExternalContent;
